<template>
  <div class="main">
    <div class="d-flex justify-content-center" v-if="loadingSpinner">
      <b-spinner variant="success" label="Spinning" style="width: 3rem; height: 3rem"></b-spinner>
    </div>

    <div v-if="!loadingSpinner">
      <form-wizard color="#B1D06C" :title="null" :subtitle="null" shape="square" finish-button-text="Submit"
        back-button-text="Previous" class="mb-3" @on-complete="formSubmitted" :disable-next-buttons="isSubmitting">
        <!-- accoint details tab -->

        <tab-content title="Customer Details">
          <b-tabs pills v-on:input="getValue($event)">
            <b-tab title="Individual" active>
              <b-card-text>
                <b-card title="Add Individual">
                  <AddIndividual @update:individual="updateIndividual" :individual="individual"
                    ref="addCustomerIndividual" />
                </b-card>
              </b-card-text>
            </b-tab>
            <b-tab title="Company">
              <b-card-text>
                <b-card title="Add Company">
                  <AddCompany @update:company="updateCompany" :company="company" ref="addCustomerCompany" />
                </b-card>
              </b-card-text>
            </b-tab>
          </b-tabs>
        </tab-content>
      </form-wizard>
    </div>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BTab,
  BCard,
  BCardText,
  BContainer,
  BSpinner,
  BTabs,
} from "bootstrap-vue";
import AddCompany from "./AddCompany.vue";
import AddIndividual from "./AddIndividual.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    BCardText,
    TabContent,
    BRow,
    BContainer,
    BCol,
    BSpinner,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormInvalidFeedback,
    ToastificationContent,
    AddCompany,
    AddIndividual,
    BTab,
    BCard,
    BTabs,
  },
  data() {
    return {
      loadingSpinner: true,
      isSubmitting: false,
      individual: {
        lName: null,
        fName: null,
        email: null,
        dob: null,
        addressLine1: null,
        addressLine2: null,
        title: null,
        brn: null,
        tel: null,
        fieldInstruction: null,
        comments: null,
        salesPersonId: null,
        profile: {
          source: null,
          city: null,
          jobTitle: null,
          hobbies: [],
          productsInterestedIn: [],
          marketingSegments: [],
        },        
        
      },

      company: {
        companyName: null,
        otherName: null,
        email: null,
        addressLine1: null,
        addressLine2: null,
        tel: null,
        fieldInstruction: null,
        website: null,
        vatNumber: null,
        comments: null,
        salesPersonId: null,
        brn: null,
        profile: {
          source: null,
          city: null,
          productsInterestedIn: [],
          marketingSegments: [],
        },
      },

      valueCheck: null,
    };
  },
  computed: {
    ...mapGetters("customerModule", {
      loading: "loading",
    }),
    otherName() {
      return this.individual.fName + " " + this.individual.lName;
    },
  },

  mounted() {
    setTimeout(() => {
      this.loadingSpinner = false;
    }, 5000);
  },
  methods: {
    ////////
    ...mapActions("customerModule", ["addCustomersAction"]),

    getValue(value) {
      this.valueCheck = value;
    },

    updateIndividual(individualData) {
      this.individual.dob = individualData.dob != "" ? individualData.dob : null;
      this.individual.fName = individualData.fName;
      this.individual.lName = individualData.lName;
      this.individual.email = individualData.email;
      this.individual.addressLine1 = individualData.addressLine1;
      this.individual.addressLine2 = individualData.addressLine2;
      this.individual.tel = individualData.tel;
       this.individual.brn = individualData.brn;
      this.individual.fieldInstruction = individualData.fieldInstruction;
      this.individual.title = individualData.title;
      this.individual.comments = individualData.comments;
      this.individual.salesPersonId = individualData.salesPersonId;
      this.individual.profile.source = individualData.profile.source;
      this.individual.profile.city = individualData.profile.city;
      // Extract hobbies array
      this.individual.profile.hobbies = individualData.profile.hobbies.map(
        (hobby) => hobby.value
      );

      // Extract productsInterestedIn array
      this.individual.profile.productsInterestedIn =
        individualData.profile.productsInterestedIn.map(
          (product) => product.value
        );
      this.individual.profile.jobTitle = individualData.profile.jobTitle;
      // extracting segment
      this.individual.profile.marketingSegments =
        individualData.profile.marketingSegments.map(
          (segment) => segment.value
        );
      this.individual.additionalFields = individualData.additionalFields;
    },

    updateCompany(companyData) {
      //console.log(details);
      this.company.companyName = companyData.companyName;
      this.company.otherName = companyData.otherName;
      this.company.email = companyData.email;
      this.company.addressLine1 = companyData.addressLine1;
      this.company.addressLine2 = companyData.addressLine2;
      this.company.tel = companyData.tel;
      this.company.fieldInstruction = companyData.fieldInstruction;
      this.company.website = companyData.website;
      this.company.vatNumber = companyData.vatNumber;
      this.company.comments = companyData.comments;
      this.company.salesPersonId = companyData.salesPersonId;
      this.company.brn = companyData.brn;
      this.company.profile.source = companyData.profile.source;
      this.company.profile.city = companyData.profile.city;
      // Extract productsInterestedIn array
      this.company.profile.productsInterestedIn =
        companyData.profile.productsInterestedIn.map(
          (product) => product.value
        );
      // extracting segment
      this.company.profile.marketingSegments =
        companyData.profile.marketingSegments.map(
          (segment) => segment.value
        );
      this.company.additionalFields = companyData.additionalFields;
    },
    async formSubmitted() {
      // Prevent double submission
      if (this.isSubmitting) {
        return;
      }
      
      this.isSubmitting = true;
      
      try {
        if (this.valueCheck == 0) {
          await this.addLeadsIndividual();
        } else {
          await this.addLeadsCompany();
        }
      } catch (error) {
        
        this.isSubmitting = false;
      }
    },
    success() {
      this.$swal({
          title: "Customer added!",
        text: "You have successfully added the Customer!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then((result) => {
        this.$router.push({ name: "customer-list" });
      });
    },

    // error
    error() {
      this.$swal({
        title: "Error!",
        text: " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    async addLeadsIndividual() {
      let isValid = await this.$refs.addCustomerIndividual.submitForm();

      if (isValid) {
        let payload = {
          otherName: this.individual.fName,
          surname: this.individual.lName,
          email: this.individual.email,
          addressLine1: this.individual.addressLine1,
          addressLine2: this.individual.addressLine2,
          tel: this.individual.tel,
          brn: this.individual.brn,
          fieldInstruction: this.individual.fieldInstruction,
          comments: this.individual.comments,
          title: this.individual.title,
          dob: this.individual.dob != "" ? this.individual.dob : null,
          type: 0,
          status: 0,
          salesPersonId: this.individual.salesPersonId,
          profile: {
            source: this.individual.profile.source,
            city: this.individual.profile.city,
            jobTitle: this.individual.profile.jobTitle,
            hobbies: this.individual.profile.hobbies.map(hobby => hobby.value),
            productsInterestedIn: this.individual.profile.productsInterestedIn != [] ? this.individual.profile.productsInterestedIn.map(product => product.value) : [],
            marketingSegments: this.individual.profile.marketingSegments.map(
              (segment) => segment.value
            ),
          },
          additionalFields: this.individual.additionalFields,
        };
       // console.log(payload)
        this.addCustomersAction(payload)
          .then((response) => {
            this.success(response);
          })
          .catch(() => {
            this.error();
          })
          .finally(() => {
            this.isSubmitting = false;
          });
      }
    },

    async addLeadsCompany() {
      let isValid = await this.$refs.addCustomerCompany.submitForm();

      if (isValid) {
        let payload = {
          otherName: this.company.otherName,
          email: this.company.email,
          companyName: this.company.companyName,
          addressLine1: this.company.addressLine1,
          addressLine2: this.company.addressLine2,
          tel: this.company.tel,
          fieldInstruction: this.company.fieldInstruction,
          website: this.company.website,
          vatNumber: this.company.vatNumber,
          comments: this.company.comments,
          type: 1,
          status: 0,
          isActive: true,
          brn: this.company.brn,
          salesPersonId: this.company.salesPersonId,
          profile: {
            source: this.company.profile.source,
            city: this.company.profile.city,
            productsInterestedIn: this.company.profile.productsInterestedIn != [] ? this.company.profile.productsInterestedIn.map(product => product.value) : [],
            marketingSegments: this.company.profile.marketingSegments.map(
              (segment) => segment.value
            ),
          },
          additionalFields: this.company.additionalFields,
        };
        this.addCustomersAction(payload)
          .then((response) => {
            this.success(response);
          })
          .catch(() => {
            this.error();
          })
          .finally(() => {
            this.isSubmitting = false;
          });
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";

.dropdown-toggle {
  text-align: left;
}
</style>
